/**
 * Integrations Hub - Unified integrations interface
 * Combines: External Systems, Data Upload, and Integration Monitoring
 */
import React, { useState } from 'react';
import { Box, Paper, Tabs, Tab } from '@mui/material';
import {
  IntegrationInstructions as ExternalIcon,
  CloudUpload as UploadIcon,
  Hub as MonitorIcon
} from '@mui/icons-material';
import ExternalIntegrations from '../Integrations/ExternalIntegrations';
import DataUpload from './DataUpload';
import IntegrationMonitoring from './IntegrationMonitoring';

const IntegrationsHub: React.FC = () => {
  const [tabValue, setTabValue] = useState(0);

  return (
    <Box>
      <Paper sx={{ mb: 2 }}>
        <Tabs
          value={tabValue}
          onChange={(_, val) => setTabValue(val)}
          variant="fullWidth"
        >
          <Tab icon={<ExternalIcon />} label="External Systems" iconPosition="start" />
          <Tab icon={<UploadIcon />} label="Data Upload" iconPosition="start" />
          <Tab icon={<MonitorIcon />} label="Monitoring" iconPosition="start" />
        </Tabs>
      </Paper>

      {tabValue === 0 && <ExternalIntegrations />}
      {tabValue === 1 && <DataUpload />}
      {tabValue === 2 && <IntegrationMonitoring />}
    </Box>
  );
};

export default IntegrationsHub;
